export const PRICING_TYPE_SIMPLE = 'simple';

export const PRICING_TYPE_BY_EMPLOYEE_CAT = 'by-employee-cat';

export const PRICING_TYPE_CUSTOM = 'custom';

export const PRICING_TYPE_2D = '2d';

export const DEFAULT_DURATION = 60;
